define('home/views/common/EnclosedDiscussionsModuleView',[
    'backbone-marionette',
    'home/views/DiscussionsModuleItemView',
], function (
    Marionette,
    DiscussionsModuleItemView
) {
    'use strict';

    /**
     * Parent class for an enclosed module that shows a list of discussions.
     * Can specify a max number to show, as a class variable called ITEMS_MAX.
     *
     * Child classes must define template which should define the content
     * region with data-role=posts.
     *
     * Expects to be backed by a collection of ActivityFeedItems that have
     * related threads.
     */
    var EnclosedDiscussionsModuleView = Marionette.CompositeView.extend({
        // must define template

        className: 'aside__wrap -padded',

        itemView: DiscussionsModuleItemView,
        itemViewContainer: '[data-role=posts]',

        addItemView: function (item, ItemView, index) {
            if (this.constructor.ITEMS_MAX && index > this.constructor.ITEMS_MAX - 1)
                return;

            return Marionette.CompositeView.prototype.addItemView.call(this, item, ItemView, index);
        },
    });

    return EnclosedDiscussionsModuleView;
});

